import { CatModal } from '@blocks-react/components/Modal';
import { ServiceInsightViewAllmodalProps } from '../../types';
import { ServiceInsightTabletMobileCard } from '../service-insight-tablet-mobile-card';
import { ServiceInsightHeading } from '../service-insight-heading';
import cx from 'classnames';
import styles from '../../customer-account.module.scss';

export const ServiceInsightViewAllModal = ({
  isOpen,
  onClose,
  isNewCount,
  serviceInsights,
  serviceInsightTranslation,
  handleRedirectUrlToAlp
}: ServiceInsightViewAllmodalProps) => {
  return (
    <CatModal
      isActive={isOpen}
      onBlModalClose={onClose}
      fullWidth
      className={styles['cat-modal']}
    >
      <div slot="header">
        <ServiceInsightHeading
          isNewCount={isNewCount}
          serviceInsightTranslation={serviceInsightTranslation}
          isViewAllBtnEnable={false}
        />
      </div>
      <div className={cx('row', styles['modal-body'])}>
        {serviceInsights.map((item) => {
          return (
            <ServiceInsightTabletMobileCard
              key={item.id}
              serviceInsights={item}
              handleRedirectUrlToAlp={handleRedirectUrlToAlp}
            />
          );
        })}
      </div>
    </CatModal>
  );
};
